// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__mNPqW","tab":"Tabs_tab__28Mkm","active":"Tabs_active__2hPHG"};